<template>
  <div>
	<div class="contentPOS brinkPOS h-100 bg-image" :style="{ backgroundImage: primaryBg}">
		<div class="container-fluid h-100">
			<div class="row h-100">
				<div class="col-xl-4 order-xl-first order-last h-100">
					<div class="card card-custom gutter-b fixed-h-100 bg-white border-colored">
						<div class="card-body">
						</div>
						<div class="product-items-brink">
							<div class="row">
								<product-card v-for="(product, index) in productsBySubsidiary" :key="index" :product="product"
								@on-product-action="onProductAction"/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-5 col-lg-8 col-md-8 h-100">
					<div class="">

						<!-- Alerta de selección de cliente -->
						<div>
							<b-alert
								:show="dismissCountDownAlertCustomerSelect"
								dismissible
								fade
								variant="danger"
								@dismiss-count-down="countDownAlertChangedCustomerSelect">
								<div class="text-center">
									<h5>{{alertMessage}}</h5>
								</div>
							</b-alert>
						</div>

						<!-- Alerta de registro de cliente -->
						<div>
							<b-alert
								:show="dismissCountDownAlertCustomerRegister"
								dismissible
								fade
								variant="success"
								@dismiss-count-down="countDownAlertChangedCustomerRegister">
								<div class="text-center">
									<h5>{{alertMessage}}</h5>
								</div>
							</b-alert>
						</div>

						<div class="card card-custom gutter-b bg-white border-0 table-contentpos">
							<div class="card-body">
								<div class="d-flex justify-content-between colorfull-select">
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-primary-brink-orange-darkpurple" title="Cliente sin registro"
											@click.stop="openClientNoRegistration">
											<i class="fas fa-user-friends"></i>
											Cliente sin registro
										</button>
									</div>
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-primary-brink-blue-darkpurple" title="Nuevo Cliente" 
											@click.stop="openClientRegistration">
											<i class="fas fa-user-plus mr-1"></i>
											Nuevo Cliente
										</button>
									</div>						
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-primary-brink-blue-darkpurple" title="Buscar Cliente"
											@click.stop="openClientSearch">
											<i class="fas fa-search mr-1"></i>
											Buscar Cliente
										</button>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div>
									<div class="d-flex flex-column selectmain">
										<button type="submit" class="btn btn-primary-brink-green-darkpurple mb-2" title="Venta sin cliente" 
											@click.stop="openFreeOrder">
											<i class="fas fa-money-bill mr-1"></i>
											Venta sin cliente
										</button>
									</div>						
								</div>
							</div>
						</div>
						
						<div class="card card-custom gutter-b bg-white border-0 table-contentpos">
								<div class="table-datapos h-100 ">
									<div class="table-responsive" id="printableTable">
										<table id="orderTable" class="display dataTable timesTable" style="width:100%">
											<thead>
												<tr>
													<th class="text-center">ID</th>
													<th class="text-center">Nombres</th>
													<th class="text-center">Inicio</th>
													<th class="text-center">Fin</th>
													<th class="text-center">Tiempo</th>
													<th class="text-center"></th>
												</tr>
											</thead>
											<tbody>
												<time-table-row v-for="(line, idx) in rent_operations" :key="idx"
													:num="line.rentNumber"
													:name="line.rentNames"
													:start="line.rentInitTime"
													:end="line.rentEndTime"
													:remaining="line.rentTime"
													:rent_id="line.operation.id"
													:phone="line.phoneNumber"
													@on-addTime-action="onAddTimeAction"
													@on-incident-action="onIncidentAction"
													@on-closeRent-action="onCloseRentAction"
													@on-printTicket-action="onPrintTicketAction"
												/>
											</tbody>
										</table>
									</div>
								</div>
						</div>	
					</div>	
				</div>
				<div class="col-xl-3 col-lg-4 col-md-4">
					<div class="card card-custom gutter-b bg-white border-0">
						<div class="card-body" >
							<div class="shop-profile-brink">
								<div class="media">
									<!--
									<div class="bg-primary-brink w-45px h-45px d-flex justify-content-center align-items-center item-number">
										<h4 class="mb-0 white">{{ randomNumber }}</h4>
									</div>
									-->
									<div class="media-body ml-3">
										<h3 class="title font-weight-bold">{{ nameClients }}</h3>
										<!--<p>Inicio: 12:30 <br>Fin: 13:30</p>-->
										<p>{{ phoneClients }}</p>
									</div>
								</div>
							</div>
							<div class="resulttable-pos" >
								<table class="table left-table">
									<tbody>
										<tr v-for="(line, idx) in orderLines" :key="idx">
											<!--<th scope="row">{{line.product_id}}</th>-->
											<td>
												<a class="text-brink-danger cursor-brink-pointer mr-4 font-20" @click.stop="deleteProductRequest(line.product_id)"><i class="fas fa-trash"></i></a>
												<a class="text-brink-info cursor-brink-pointer font-20" @click.stop="editProductRequest(line.product_id)"><i class="fas fa-edit"></i></a>
											</td>
											<th class="text-center" style="font-size: small">{{line.pieces}}</th>
											<th class="text-center" style="font-size: small">{{line.product_name}}</th>
											<th class="text-right"  style="font-size: small">${{fixedFormat(line.subtotal,2)}}</th>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="d-flex justify-content-end align-items-center flex-column">
								<div>
									<h2 class="border-0 justify-content-end d-flex text-primary-brink-darkpurple font-size-h2">Total:${{fixedFormat(totalOrder,2)}}</h2>
								</div>
							</div>
							<hr class="my-3">
							<div class="d-flex justify-content-end align-items-center flex-column">
								<div class="d-flex flex-column selectmain"> 
									<button type="submit" class="btn btn-primary-brink-orange-darkpurple mb-2"  title="Confirmar orden" @click.stop="confirmOrder">
										<i class="fas fa-check"></i>
										Confirmar
									</button>
									<button type="submit" class="btn btn-primary-brink-green-darkpurple mb-2" title="Cancelar" @click.stop="cancelOrder">
										<i class="fas fa-undo"></i>
										Cancelar
									</button>
								</div>
							</div>
						</div>	
					</div>
				</div>

				<!-- Modal para seleccionar sucursal si es usuario Admin -->
				<div>
					<b-modal ref="modal-subsidiaries" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true">
						<div>
							<b-form-select 
								v-model="subsidiarySelected"
								:options="subsidiariesInfo"
								class="m-2"
								value-field="subsidiary_id"
								text-field="subsidiary_name"
								@change="onChangeSubsidiary">
							</b-form-select>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Sucursal:</h5>
								<h5>{{ subsidiaryName }}</h5>
							</div>
						</div>
						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelSubsidiarySelection">
								Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="confirmSubsidiarySelection">
								Confirmar
							</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para seleccionar cliente sin registro -->
				<div>
					<b-modal ref="modal-no-register-client" size="lg" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
						<h2 class="text-center">Cliente sin registro</h2>
						<hr class="my-3">
						<div class="modal-body">
							<form id="formNoRegisterCustomer" @submit.prevent="confirmNoRegistrationCustomer">
								<div class="form-group row">
									<div class="col-md-6">
										<b-form-group
											id="customerNoRegisterNameSet"
											description="Dato requerido."
											label="Nombre(s)"
											label-for="customersName"											
											valid-feedback="Completado"
											:invalid-feedback="invalidFeedbackNameNoRegisterCustomer"
											:state="stateNameNoRegisterCustomer"
										>
											<b-form-input type="text" class="form-control"
												name="customersName" id="customersName" v-model="customersName"
												:state="stateNameNoRegisterCustomer" trim>
											</b-form-input>
										</b-form-group>	
									</div>
									<div class="col-md-6">
										<b-form-group
											id="customerNoRegisterPhoneSet"
											description="Dato requerido."
											label="Teléfono"
											label-for="customersPhone"											
											valid-feedback="Completado"
											:invalid-feedback="invalidFeedbackPhoneNoRegisterCustomer"
											:state="statePhoneNoRegisterCustomer"
										>
											<b-form-input type="number" class="form-control"
												name="customersPhone" id="customersPhone" v-model="customersPhone"
												:state="statePhoneNoRegisterCustomer" :formatter="formatPhone">
											</b-form-input>
										</b-form-group>
									</div>
								</div>
							</form>
						</div>
						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelNoRegistrationCustomer">
								Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" type="submit" form="formNoRegisterCustomer">
								Confirmar
							</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para registrar cliente -->
				<div>
					<b-modal ref="modal-register-client" size="lg" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
						<h2 class="text-center">Registro de cliente</h2>
						<hr class="my-3">
						<div class="modal-body">
							<form id="formRegisterCustomer" @submit.prevent="confirmRegistrationCustomer">							
								<div class="form-group row">
									<div class="col-md-6">
										<b-form-group
											id="customerNameSet"
											description="Dato requerido."
											label="Nombre(s)"
											label-for="customerRegisterName"											
											valid-feedback="Completado"
											:invalid-feedback="invalidFeedbackNameRegisterCustomer"
											:state="stateNameRegisterCustomer"
										>
											<b-form-input type="text" class="form-control"
												name="customerRegisterName" id="customerRegisterName" v-model="customerRegisterName"
												:state="stateNameRegisterCustomer" trim>
											</b-form-input>
										</b-form-group>	
									</div>
									<div class="col-md-6">
										<b-form-group
											id="customerLastNameSet"
											description="Dato requerido."
											label="Apellido(s)"
											label-for="customerRegisterLastName"											
											valid-feedback="Completado"
											:invalid-feedback="invalidFeedbackLastNameRegisterCustomer"
											:state="stateLastNameRegisterCustomer"
										>
											<b-form-input type="text" class="form-control"
												name="customerRegisterLastName" id="customerRegisterLastName" v-model="customerRegisterLastName"
												:state="stateLastNameRegisterCustomer" trim>
											</b-form-input>
										</b-form-group>	
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6">
										<b-form-group
											id="customerMailSet"
											description=""
											label="Correo electrónico"
											label-for="customerRegisterMail"											
											valid-feedback="Correo electrónico válido"
											:invalid-feedback="invalidFeedbackMailRegisterCustomer"
											:state="stateMailRegisterCustomer"
										>
											<b-form-input type="mail" class="form-control"
												name="customerRegisterMail" id="customerRegisterMail" v-model="customerRegisterMail"
												:state="stateMailRegisterCustomer" trim>
											</b-form-input>
										</b-form-group>	
									</div>
									<div class="col-md-6">
										<b-form-group
											id="customerPhoneSet"
											description="Dato requerido."
											label="Teléfono"
											label-for="customerRegisterPhone"											
											valid-feedback="Completado"
											:invalid-feedback="invalidFeedbackPhoneRegisterCustomer"
											:state="statePhoneRegisterCustomer"
										>
											<b-form-input type="number" class="form-control"
												name="customerRegisterPhone" id="customerRegisterPhone" v-model="customerRegisterPhone"
												:state="statePhoneRegisterCustomer" :formatter="formatPhone">
											</b-form-input>
										</b-form-group>	
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6">
										<label  class="text-body">Fecha de cumpleaños</label>
										<fieldset class="form-group mb-3">
											<b-form-input type="date" v-model="customerBirthdate"></b-form-input>
										</fieldset>
									</div>
								</div>
								<div class="form-group row">
								</div>
							</form>
						</div>
						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelRegistrationCustomer">
								Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" type="submit" form="formRegisterCustomer">
								Registrar
							</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para seleccionar cliente -->
				<div>
					<b-modal ref="modal-select-client" size="lg" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
						<h2 class="text-center">Clientes registrados</h2>
						<hr class="my-3">
						<div class="card card-custom gutter-b fixed-h-100 bg-white">´
							<b-form-group
								label="Buscar:"
								label-for="filter-customers"
								label-cols-sm="1"
								label-align-sm="right"
								label-size="xl"
								class="mb-0"
							>
								<b-input-group size="sm">
									<b-form-input
									id="filter-customers"
									v-model="filterCustomers"
									type="search"
									placeholder="Ingresa datos del cliente ..."
									>
									</b-form-input>
								</b-input-group>
							</b-form-group>
							<b-table
								:items="customersRegister"
								:fields="customersRegisterFields"
								:select-mode="customersRegisterSelectMode"
								:head-variant="dark"
								:filter="filterCustomers"
								:filter-included-fields="filterCustomersOn"
								no-sort-reset
								selectable
								responsive
								ref="selectCustomerTable"
								@row-selected="onRowCustomerSelected"
							>
								<template #cell(Seleccionado)="{ rowSelected }">
									<template v-if="rowSelected">
										<span aria-hidden="true">&check;</span>
										<span class="sr-only">Selected</span>
									</template>
									<template v-else>
										<span aria-hidden="true">&nbsp;</span>
										<span class="sr-only">Not selected</span>
									</template>
								</template>
							</b-table>
						</div>
						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelSelectCustomer">
								Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="confirmSelectCustomer">
								Seleccionar
							</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para seleccionar producto -->
				<div>
					<b-modal ref="modal-select-product" :hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">

						<div class="text-center">
							<h2>{{currentProductName}}</h2>
						</div>
						<hr class="my-3">
						<div class="row align-items-center mt-2">
							<div class="col-lg-7 col-6 text-right">
								<span class="font-15">Precio:</span>
							</div>
							<div class="col-lg-5 col-6 text-left">
								<h4>{{currentProductPrice}}</h4>
							</div>
						</div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-7 col-6 text-right">
								<span class="font-15">Cantidad:</span>
							</div>
							<div class="col-lg-5 col-6 text-right">
							<input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputPieces" id="inputPieces" min="1" v-model="currentPieces" v-on:keypress="NumbersOnly">
							</div>
						</div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
								<div class="input-group mt-1">
									<div class="input-group-prepend">
										<span class="input-group-text">$</span>
									</div>
									<input type="text" class="form-control-plaintext pl-3 form-control-high" name="inputStaticValue" id="inputStaticValue" readonly v-model="formattedAmount" >
								</div>
							</div>
							<div class="col-12 text-right mt-1" v-if="errorMssg">
								<div class="text-error">{{errorMssg}}</div>
							</div>
						</div>

						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="closeSelectProduct">
							Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-orange-darkpurple" @click.stop="confirmProductToOrder">
							Confirmar
							</b-button>
						</template>

					</b-modal>
				</div>

				<!-- Modal para seleccionar forma de pago -->
				<div>
					<b-modal ref="modal-payment-method" :hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="paymentMethodSelected"
									:options="paymentMethods"
									class="m-2"
									value-field="payment_method_id"
									text-field="payment_method_name"
									@change="onChangePaymentMethod">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Forma de pago:</h5>
								<h5>{{ paymentMethodName }}</h5>
							</div>
						</div>
						<div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-7 col-6 text-right">
								<span class="font-15">Recibido:</span>
							</div>
							<div class="col-lg-5 col-6 text-right">
							<input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputPayment" id="inputPayment" min="1" v-model="cashPayment" v-on:keypress="NumbersOnly">
							</div>
						</div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
								<div class="input-group mt-1">
									<div class="input-group-prepend">
										<span class="input-group-text">Total:</span>
									</div>
									<input type="text" class="form-control-plaintext pl-3 form-control-high" style="font-size: 1.0em" name="inputTotalPayment" id="inputTotalPayment" readonly v-model="formattedAmountTotal" >
								</div>
							</div>
							<div class="col-12 text-right mt-1" v-if="errorMssg">
								<div class="text-error">{{errorMssg}}</div>
							</div>
						</div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
								<div class="input-group mt-1">
									<div class="input-group-prepend">
										<span class="input-group-text">Cambio:</span>
									</div>
									<input type="text" class="form-control-plaintext pl-3 form-control-high" style="font-size: 1.0em" name="inputReturn" id="inputReturn" readonly v-model="formattedAmountReturn" >
								</div>
							</div>
							<div class="col-12 text-right mt-1" v-if="errorMssg">
								<div class="text-error">{{errorMssg}}</div>
							</div>
						</div>
						</div>
						<template #modal-footer>
							<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelPaymentMethodSelection">
								Cancelar
							</b-button>
							<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.once="confirmPaymentMethodSelection">
								Confirmar
							</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para adicionar tiempo a tarjeta (renta) -->
				<div>
					<b-modal ref="modal-addtime-rent" :hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
            		<h2 class="text-center">Añadir tiempo</h2>
						<hr class="my-3">
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="productToAddTimeSelected"
									:options="productsToAddTime"
									class="m-2"
									value-field="product_id"
									text-field="product_name"
									@change="onChangeProductToAddTime">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Tiempo seleccionado:</h5>
								<h5>{{ productsToAddTimeName }}</h5>
							</div>
						</div>
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="paymentMethodSelected"
									:options="paymentMethods"
									class="m-2"
									value-field="payment_method_id"
									text-field="payment_method_name"
									@change="onChangePaymentMethod">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Forma de pago:</h5>
								<h5>{{ paymentMethodName }}</h5>
							</div>
						</div>
						<div>
							<div class="row align-items-center mt-2">
								<div class="col-lg-7 col-6 text-right">
								<span class="font-15">Clientes:</span>
								</div>
								<div class="col-lg-5 col-6 text-right">
								<input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputQtyToAddTime" id="inputQtyToAddTime" min="1" v-model="qtyCustomersToAddTime" v-on:keypress="NumbersOnly">
								</div>
							</div>
						</div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelAddTimeToRent">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.once="confirmAddTimeToRent">
							Añadir
						</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para registrar incidencia -->
				<div>
					<b-modal ref="modal-register-incident" 
						:hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
						<h2 class="text-center">Incidencia</h2>
						<hr class="my-3">
						<div>
						<b-form-textarea
							v-model="incidentCommentToRegister"
							placeholder="Ingresa comentarios de incidencia ..."
							no-resize
						></b-form-textarea>
									</div>
						<div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-7 col-6 text-right">
							<span class="font-15">Monto:</span>
							</div>
							<div class="col-lg-5 col-6 text-right">
							<input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputIncidentAmount" id="inputIncidentAmount" min="1" v-model="incidentAmountToRegister" v-on:keypress="NumbersOnly">
							</div>
						</div>
						</div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelRegisterIncident">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.stop="confirmRegisterIncident">
							Registrar
						</b-button>
						</template>
					</b-modal>
				</div>

				<!-- Modal para venta sin registro -->
				<div>
					<b-modal ref="modal-freeOrder" :hide-backdrop="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
            		<h2 class="text-center">Venta sin cliente</h2>
						<hr class="my-3">
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="productToFreeOrderSelected"
									:options="productsToFreeOrder"
									class="m-2"
									value-field="product_id"
									text-field="product_name"
									@change="onChangeProductToFreeOrder">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Producto seleccionado:</h5>
								<h5>{{ productsToFreeOrderName }}</h5>
							</div>
						</div>
						<div>
							<div class="row align-items-center mt-2">
								<b-form-select 
									v-model="paymentMethodSelected"
									:options="paymentMethods"
									class="m-2"
									value-field="payment_method_id"
									text-field="payment_method_name"
									@change="onChangePaymentMethod">
								</b-form-select>
							</div>
							<div class="p-3 bg-light-dark d-flex justify-content-between border-bottom">
								<h5 class="font-size-bold mb-0">Forma de pago:</h5>
								<h5>{{ paymentMethodName }}</h5>
							</div>
						</div>
						<div>
							<div class="row align-items-center mt-2">
								<div class="col-lg-7 col-6 text-right">
								<span class="font-15">Cantidad:</span>
								</div>
								<div class="col-lg-5 col-6 text-right">
								<input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputQtyToFreeOrder" id="inputQtyToFreeOrder" min="1" v-model="qtyProductsToFreeOrder" v-on:keypress="NumbersOnly">
								</div>
							</div>
						</div>
						<div class="row align-items-center mt-2">
							<div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
								<div class="input-group mt-1">
									<div class="input-group-prepend">
										<span class="input-group-text">$</span>
									</div>
									<input type="text" class="form-control-plaintext pl-3 form-control-high" name="inputAmountToFreeOrder" id="inputAmountToFreeOrder" readonly v-model="formattedAmountFreeOrder" >
								</div>
							</div>
							<div class="col-12 text-right mt-1" v-if="errorMssg">
								<div class="text-error">{{errorMssg}}</div>
							</div>
						</div>
						<template #modal-footer>
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button size="sm" class="btn btn-primary-brink-green-darkpurple" @click.stop="cancelAddProductFreeOrder">
							Cancelar
						</b-button>
						<b-button size="sm" class="btn btn-primary-brink-blue-darkpurple" @click.once="confirmAddProductFreeOrder">
							Confirmar venta
						</b-button>
						</template>
					</b-modal>
				</div>

			</div>
		</div>
	</div>

  </div>
</template>

<script>

import ProductCard from '../../components/pos/ProductCard.vue';
import TimeTableRow from '../../components/pos/TimeTableRow.vue';
import {Product} from '../../classes/product';
import {Subsidiary} from '../../classes/subsidiary';
import {CustomerRegister} from '../../classes/customer_register';
import {SaleLine} from '../../classes/sale_line';
import {RentLine} from '../../classes/rent_line';
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import formatHelper from "@mixins/formatHelper"
import notificationsHelper from "@mixins/notificationsHelper"

export default {
  components: { ProductCard, TimeTableRow },
  mixins: [formatHelper, notificationsHelper],
  data() {
    return {
      banner: require("@assets/images/carousel/element-banner2-right.jpg"),
	  primaryBg: `url(${require('@assets/images/misc/brink-bg.png')})`,
	  subsidiarySelected: null,
	  subsidiaryName: null,
	  subsidiariesInfo: [],
	  configsSubsidiaryInfo: [],
	  productsBySubsidiary: [],
	  // Alertas
	  hasError: false,
	  closingRentID: null,
	  dismissSecsAlert: 1,
	  dismissCountDownAlertCustomerSelect: 0,
      dismissCountDownAlertCustomerRegister: 0,
	  alertMessage: null,
	  // Registro de cliente
	  customerRegisterName: '',
	  customerRegisterLastName: '',
	  customerRegisterMail: '',
	  customerRegisterPhone: '',
	  customerBirthdate: '',
	  customerRegisterNameValid: false,
	  customerRegisterLastNameValid: false,
	  customerRegisterPhoneValid: false,
	  // Selección de cliente
	  customersRegister: [],
	  customersRegisterFields: [{ key: 'customer_register_name', label: 'Nombre', sortable: true, thStyle: 'font-size: small'}, 
	  							{ key: 'customer_register_last_name', label: 'Apellido', thStyle: 'font-size: small'},
	  							{ key: 'customer_register_email', label: 'Email', thStyle: 'font-size: small'}, 
								{ key: 'customer_register_phone', label: 'Teléfono', thStyle: 'font-size: small'},
								{ key: 'customer_register_birthdate', label: 'Cumpleaños', thStyle: 'font-size: small'},
								{key: 'Seleccionado', label: '', thStyle: 'font-size: small'}
								],
	  filterCustomers: null,
	  filterCustomersOn: ['customer_register_name', 'customer_register_last_name', 'customer_register_email', 'customer_register_phone'],
	  customersRegisterSelectMode: 'single',
	  currentRegisterClient: null,
	  nameClients: null,
	  phoneClients: null,
	  customersName: '',
	  customersNameValid: false,
	  customersPhoneValid: false,
	  customersPhone: '',
	  activeCustomer: false,
	  // Selección de producto
	  currentProduct: null,
	  currentProductId: null,
	  currentProductName: null,
	  currentProductDescription: null,
	  currentProductPrice: null,
	  currentPieces: 1,
	  currentAmount: 0,
	  // Varios
	  //randomNumber: 0,
	  formattedAmount: null,
	  errorMssg: null,
	  // Orden
	  currentOrder: null,
	  totalOrder: null,
	  // Renta
	  NameClientsRent: null,
	  NumberClientsRent: null,
	  // Lineas de orden
	  orderLines: [],
	  orderLinesFreeTime: [],
	  totalTicketFreeTime: 0,
	  // Forma de pago
	  paymentMethods: [],
	  paymentMethodSelected: 1, // EFECTIVO
	  paymentMethodName: null,
	  cashPayment: 1,
	  formattedAmountReturn: 0,
	  formattedAmountTotal: 0,
	  rentType: 'NORMAL',
	  rentFreeTimeId: null,
	  // Pos Configs
	  dobleTiempo: false,
	  // Añadir tiempo
	  productToAddTimeSelected: 1,
	  productsToAddTime: [],
	  productsToAddTimeName: '',
	  qtyCustomersToAddTime: 1,
	  qtyTimeMinutesProduct: 0,
	  priceTimeMinutesProduct : 0,
	  addTimeRentId: null,
	  operationStored: null,
	  // Registrar incidencia
	  incidentRentId: null,
	  incidentCommentToRegister: '',
	  incidentAmountToRegister: 1,
	  // Ticket
	  initTimeTicket: '',
	  endTimeTicket: '',
	  // Confirmación de operaciones
	  normalOrderStored: false,
	  freeTimeOrderStored: false,
	  infoUpdated: false,
	  saleLineStored: false,
	  // Carritos
	  linesBySale: [],
	  productsObtained: false,
	  extraMinutesToPay: false,
	  costMinExtra: 0, 
	  qtyMinExtra: 0,
	  totalMinExtra: 0,
	  rentCarId: null,
	  // Venta libre
	  productToFreeOrderSelected: 1,
	  productsToFreeOrder: [],
	  productsToFreeOrderName: '',
	  qtyProductsToFreeOrder: 1,
	  priceProductToFreeOrder: 0,
	  formattedAmountFreeOrder: 0,
	  amountFreeOrder: 0,
	  freeOrderStored: false
    }
  },
  watch: {
	currentPieces(n,o){
		this.updateProductUI()
	},
	cashPayment(n,o){
		this.updateCashAmounts()
	},
	qtyProductsToFreeOrder(n,o){
		this.updateAmountFreeOrder()
	}
  },  
  async mounted(){

	// Se obtiene listado de sucursales
	await this.getSubsidiariesInfo();

	// Se valida el rol de usuario y la sucursal
	var role = this.user.meta_type;

	if(this.getUserSubsidiary === null){
		if(role === "Admin"){
			this.openModalSubsidiary();
		}
		if (role === "Vendor"){
			// Se setea información de sucursal para Vendor
			this.setUserSubsidiary(this.getSubsidiaryById(this.user.meta_info.subsidiary_id))
			// Se obtiene configuraciones de sucursal
			await this.getPosConfigBySubsidiary()
			// Se obtiene listado de productos
			await this.getProductsBySubsidiary()
			// Se obtienen operaciones activas (si aplica)
			await this.getActiveOperationsBySubsidiary()
			// Se obtiene clientes registrados
			await this.getCustomersRegister()
			// Se obtienen métodos de pago
			await this.getPaymentMethods()
		}
	}

	// Se obtiene configuraciones de sucursal
	await this.getPosConfigBySubsidiary()
	// Se obtiene listado de productos
	await this.getProductsBySubsidiary()
	// Se obtienen operaciones activas (si aplica)
	await this.getActiveOperationsBySubsidiary()
	// Se obtiene clientes registrados
	await this.getCustomersRegister()
	// Se obtienen métodos de pago
	await this.getPaymentMethods()

	// Actualizador de tiempos
	this.startTimer();

  }, 
  computed: {
    ...mapState("auth", ["user", "is_logged"]),
	...mapState("general", ["rent_operations"]),
	...mapGetters("general", ["getUserSubsidiary", "getSubsidiaries", "getProductsSubsidiary"]),
    ...mapMutations("auth", ["cleanSession"]),
    ...mapMutations("general", ["cleanSubsidiariesInfo"]),

	stateNameNoRegisterCustomer() {
		if(this.customersName.length >= 2){
			this.customersNameValid = true
			return true
		}else{
			this.customersNameValid = false
			return false
		}
	},
	invalidFeedbackNameNoRegisterCustomer() {
		this.customersNameValid = false
		if (this.customersName.length > 0) {
			return 'Ingresa al menos 2 letras.'
		}
		return 'Ingresa datos.'
	},
	statePhoneNoRegisterCustomer() {
		if(this.customersPhone.length >= 10){
			this.customersPhoneValid = true
			return true
		}else{
			this.customersPhoneValid = false
			return false
		}
	},
	invalidFeedbackPhoneNoRegisterCustomer() {
		this.customersPhoneValid = false
		if (this.customersPhone.length > 0) {
			return 'Ingresa al menos 10 dígitos.'
		}
		return 'Ingresa datos.'
	},
	stateNameRegisterCustomer() {
		if(this.customerRegisterName.length >= 2){
			this.customerRegisterNameValid = true
			return true
		}else{
			this.customerRegisterNameValid = false
			return false
		}
	},
	invalidFeedbackNameRegisterCustomer() {
		this.customerRegisterNameValid = false
		if (this.customerRegisterName.length > 0) {
			return 'Ingresa al menos 2 letras.'
		}
		return 'Ingresa datos.'
	},
	stateLastNameRegisterCustomer() {
		if(this.customerRegisterLastName.length >= 2){
			this.customerRegisterLastNameValid = true
			return true
		}else{
			this.customerRegisterLastNameValid = false
			return false
		}
	},
	invalidFeedbackLastNameRegisterCustomer() {
		this.customerRegisterLastNameValid = false
		if (this.customerRegisterLastName.length > 0) {
			return 'Ingresa al menos 2 letras.'
		}
		return 'Ingresa datos.'
	},
	statePhoneRegisterCustomer() {
		if(this.customerRegisterPhone.length >= 10){
			this.customerRegisterPhoneValid = true
			return true
		}else{
			this.customerRegisterPhoneValid = false
			return false
		}
	},
	invalidFeedbackPhoneRegisterCustomer() {
		this.customerRegisterPhoneValid = false
		if (this.customerRegisterPhone.length > 0) {
			return 'Ingresa al menos 10 dígitos.'
		}
		return 'Ingresa datos.'
	},
	stateMailRegisterCustomer() {
		return this.validEmail(this.customerRegisterMail)
	},
	invalidFeedbackMailRegisterCustomer() {
		if (this.validEmail(this.customerRegisterMail)) {
			return 'Ingresa correo electrónico válido.'
		}
		return ''
	}
  },
  methods: {
	...mapState("general", ["rent_operations"]),
	...mapMutations("general", ["setUserSubsidiary", "setSubsidiaries", "setProductsSubsidiary", "setRentOperation", "cleanRentOperation", "cleanRentOperations"]),
	...mapGetters("general", ["getUserSubsidiary", "getSubsidiaries", "getRentOperations"]),
    startTimer(){
      setInterval(() => {
        this.updateTimeOperations()
      }, 1000)
    },
    updateTimeOperations(){

		var now_time = null
		var init_time =  null
		var diff_time = null
		var diff_on_minutes = 0

		// Se recorren lineas de renta para ir actualizando tiempo restante
		this.getRentOperations().forEach(rentOperation => {

			let timeNoYet = false
			// Hora actual
			now_time = new Date()
			// Hora inicial
			init_time = new Date()
			init_time.setHours(rentOperation.operation.start_time.substring(11,13), 
							 	rentOperation.operation.start_time.substring(14,16),
								rentOperation.operation.start_time.substring(17,19))
			// Minutos transcurridos
			diff_time = now_time - init_time
			diff_on_minutes = Math.floor(diff_time / 60000)
			
			// Se evaluan horas que aún no se cumplen
			timeNoYet = (init_time.getTime() > now_time.getTime())?true:false
			if(timeNoYet)
				diff_on_minutes = 0

			// Si es tiempo libre 
			if(parseInt(rentOperation.operation.minutes_used) === 0){
				rentOperation.rentTime = diff_on_minutes
			// Si es tiempo normal
			}else{	
				if(diff_on_minutes > rentOperation.operation.minutes_used){
					diff_on_minutes = rentOperation.operation.minutes_used - diff_on_minutes
					rentOperation.rentTime = diff_on_minutes
				}else{
					rentOperation.rentTime = rentOperation.operation.minutes_used - diff_on_minutes
				}
			}

		});

		// Se ordenan tarjetas de operaciones
		this.getRentOperations().sort(function (a,b){
			return a.rentTime - b.rentTime;
		});

    },
    openModalSubsidiary() {
	  this.$refs['modal-subsidiaries'].show();
    },
	async getSubsidiariesInfo(){
		//this.showLoader("Obteniendo información de sucursales ...")
		const res = await this.xget('/api/subsidiaries_info');
		if(res.success){
			this.setSubsidiariesInfo(res.data);
		}
		//this.stopLoader()
	},
	setSubsidiariesInfo(rawSubsidiaries){
		this.subsidiariesInfo = [];
		rawSubsidiaries.forEach(subsidiary => {
			this.subsidiariesInfo.push(Subsidiary.fromServiceSubsidiaries(subsidiary));
		});
		// Se almacenan sucursales en state
		this.setSubsidiaries(this.subsidiariesInfo);
	},
	async getPosConfigBySubsidiary(){
		const res = await this.xget('/api/pos_configs_subsidiary/'+this.getUserSubsidiary.subsidiary_id);
		if(res.success){
			this.setPosConfigBySubsidiary(res.data);
		}
	},
	setPosConfigBySubsidiary(configsSubsidiary){
		this.configsSubsidiaryInfo = []
		configsSubsidiary.forEach(config => {
			var config_subsidiary = {
				pos_config_id: config.pos_config_id,
				pos_config_name: config.pos_config_name,
				pos_config_value: config.pos_config_value
			};
			this.configsSubsidiaryInfo.push(config_subsidiary);
		});
	},
	async getProductsBySubsidiary(){
		//this.showLoader("Obteniendo información de productos ...")
		const res = await this.xget('/api/products_subsidiary/'+this.getUserSubsidiary.subsidiary_id);
		if(res.success){
			this.setProductsInfo(res.data);
		}
		//this.stopLoader()
	},      
	setProductsInfo(rawProducts){
		this.productsBySubsidiary = [];
		rawProducts.forEach(product => {
			this.productsBySubsidiary.push(Product.fromServiceProductsBySubsidiary(product));
		});
		// Se almacenan en state los productos de sucursal
		this.setProductsSubsidiary(this.productsBySubsidiary);
	},
	async getCustomersRegister(){
		//this.showLoader("Obteniendo información de clientes registrados ...")
		const res = await this.xget('/api/customers_info');
		if(res.success){
			this.setCustomersRegisterInfo(res.data);
		}
		//this.stopLoader()
	},      
	setCustomersRegisterInfo(rawCustomers){
		this.customersRegister = [];
		rawCustomers.forEach(customer => {
			this.customersRegister.push(CustomerRegister.fromServiceCustomers(customer));
		});
	},
    onChangeSubsidiary: function(event) {
		this.subsidiaryName = this.getSubsidiaryById(this.subsidiarySelected).subsidiary_name;
    },
	getSubsidiaryById(subsidiary_id){
		let subsidiary = this.subsidiariesInfo.find(sub => sub.subsidiary_id === subsidiary_id);
		return subsidiary;
	},
	async confirmSubsidiarySelection(){
		let subsidiary = this.getSubsidiaryById(this.subsidiarySelected)
		// Se setea información de sucursal para Admin
		this.setUserSubsidiary(subsidiary)
		// Se obtiene configuraciones de sucursal
		await this.getPosConfigBySubsidiary()
		// Se obtiene listado de productos
		await this.getProductsBySubsidiary()
		// Se obtienen operaciones activas (si aplica)
		await this.getActiveOperationsBySubsidiary()
		// Se obtiene clientes registrados
		await this.getCustomersRegister()
		// Se obtienen métodos de pago
		await this.getPaymentMethods()
		this.$refs['modal-subsidiaries'].hide()
	},
	async cancelSubsidiarySelection(){
      this.cleanSubsidiariesInfo;
      this.cleanSession;
      await this.$router.replace({name: 'login'});
	},
	async getActiveOperationsBySubsidiary(){
		const res = await this.xget('/api/active_operations/'+this.getUserSubsidiary.subsidiary_id);
		if(res.success){
			this.setActiveOperationsInfo(res.data);
		}
	},
	setActiveOperationsInfo(active_operations){
		// Se limpian tarjetas y se construyen nuevamente
		this.cleanRentOperations()
		active_operations.forEach(op => {
			this.createRentLine(op.operation, op.operation.consecutive_sale)
		});
		// Dummy para limpiar operaciones
		//this.cleanRentOperations()
	},
	async getPaymentMethods(){
		const res = await this.xget('/api/payment_methods_info');
		if(res.success){
			this.setPaymentMethodsInfo(res.data);
		}
	},
	setPaymentMethodsInfo(rawPaymentMethods){
		this.paymentMethods = [];
		rawPaymentMethods.forEach(paymentMethod => {
			var pay_method = {
				payment_method_id: paymentMethod.payment_method_id,
				payment_method_name: paymentMethod.payment_method_name
			};
			this.paymentMethods.push(pay_method);
		});
	},
    onChangePaymentMethod: function(event) {
		this.paymentMethodName = this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name;
    },
	getPaymentMethodById(payment_method_id){
		let payment_method = this.paymentMethods.find(pm => pm.payment_method_id === payment_method_id);
		return payment_method;
	},
	openClientNoRegistration(){
		this.customersName = ''
		this.customersPhone = ''
		this.$refs['modal-no-register-client'].show();
	},
	openClientRegistration(){
		this.cleanCustomerRegisterInfo()
		this.$refs['modal-register-client'].show();
	},
	async openClientSearch(){
		await this.getCustomersRegister()
		this.$refs['modal-select-client'].show();
	},
	async openFreeOrder(){

		// Se obtienen productos para tiempo adicional.
		let productsSubsidiary = this.getProductsSubsidiary

		if (this.getUserSubsidiary.subsidiary_trade === 'Brincolines'){
			this.productsToFreeOrder = productsSubsidiary.filter(f => f.product_type === 'DULCERIA' || f.product_type === 'CALCETAS' ||
																	  f.product_type === 'ARTICULO COVID' || f.product_type === 'OTROS')
		}

		if (this.getUserSubsidiary.subsidiary_trade === 'Carritos'){
			this.productsToFreeOrder = productsSubsidiary.filter(f => f.product_type === 'DULCERIA' || f.product_type === 'ARTICULO COVID' || f.product_type === 'OTROS')
		}

		// Se ordenan productos
		this.productsToFreeOrder.sort(function (a,b){
			return a.product_name > b.product_name;
		});

		// Se escoge primer producto del listado
		if(this.productsToFreeOrder.length > 0){
			this.productToFreeOrderSelected = this.productsToFreeOrder[0].product_id
			this.productsToFreeOrderName = this.productsToFreeOrder[0].product_name
			this.priceProductToFreeOrder = this.productsToFreeOrder[0].product_subsidiary_cost
		}
		// Se inicializa cantidad en 1
		this.qtyProductsToFreeOrder = 1
		this.amountFreeOrder = this.priceProductToFreeOrder
		this.formattedAmountFreeOrder = this.fixedFormat(parseInt(this.priceProductToFreeOrder),2)
		// Efectivo
		this.paymentMethodSelected = 1
		this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
		this.$refs['modal-freeOrder'].show();
	},
    onChangeProductToFreeOrder: function(event) {
		let ProductToFreeOrder = this.productsToFreeOrder.find(f => f.product_id === this.productToFreeOrderSelected)
		if(ProductToFreeOrder){
			this.productsToFreeOrderName = ProductToFreeOrder.product_name
			this.priceProductToFreeOrder = ProductToFreeOrder.product_subsidiary_cost
		}
		this.updateAmountFreeOrder()
    },
	cancelAddProductFreeOrder(){
		this.$refs['modal-freeOrder'].hide();
	},
	async confirmAddProductFreeOrder(){

		if(!this.qtyProductsToFreeOrder || this.qtyProductsToFreeOrder <= 0){
			this.warningNotif('ATENCIÓN:', '¡Ingresa una cantidad de productos válida!')
			this.$refs['modal-freeOrder'].hide();
		}else{

			this.freeOrderStored = false

			// Se cierra modal para evitar más peticiones
			this.$refs['modal-freeOrder'].hide();

			// Se registra información de venta
			await this.registerFreeOrder(this.qtyProductsToFreeOrder, this.productToFreeOrderSelected, this.priceProductToFreeOrder, this.amountFreeOrder)

			// Si se crea la venta, lineas de venta y pago se genera ticket
			if(this.freeOrderStored){
				// Se notifica al usuario
				this.successNotif("VENTA LIBRE:", '¡Registrada correctamente!')
				// Se imprime ticket
				//await this.getTicketFreeOrder(this.qtyProductsToFreeOrder, this.productsToFreeOrderName, this.formattedAmountFreeOrder)
			}
		}
	},
	addProductToOrder(){
      this.$refs['modal-select-product'].show();
	},
	async onProductAction(product){
		if(!this.activeCustomer){
			this.alertMessage = 'Selecciona un cliente antes de agregar productos'
			this.dismissCountDownAlertCustomerSelect = this.dismissSecsAlert
		}else{
			// Se valida si el producto ya existe en la orden para cargar cantidad
			let existing = this.orderLines.find(f => f.product_id === product.product_id)
			this.currentProduct = product
			this.currentPieces = (existing ? parseInt(existing.pieces) : 1)
			this.currentProductName = (this.currentProduct) ? this.currentProduct.product_name : "-";
			this.currentProductDescription = (this.currentProduct) ? this.currentProduct.product_description : "-";
			let p = (this.currentProduct) ? this.currentProduct.product_subsidiary_cost : 0;
			this.currentProductPrice = this.explicitMoneyFormat(p);
			this.currentAmount = Math.max(this.currentProduct.product_subsidiary_cost * this.currentPieces, 0)
			this.formattedAmount = this.fixedFormat(this.currentAmount, 2)
			this.openSelectProduct();
		}
	},
	openSelectProduct(){
		this.$refs['modal-select-product'].show();
	},
	closeSelectProduct(){
		this.$refs['modal-select-product'].hide();
	},
	confirmProductToOrder(){
		// Se valida cantidad a agregar
		if(this.currentPieces <= 0){
			this.warningNotif('ATENCIÓN:', '¡Ingresa una cantidad válida!')
		}else{
			// Se busca si el producto ya fue agregado a la orden
			let existing = this.orderLines.find(f => f.product_id === this.currentProduct.product_id)
			if (existing){
				// Se actualiza piezas y subtotal de producto por agregar
				existing.pieces = this.currentPieces
				let p = (this.currentProduct) ? this.currentProduct.product_subsidiary_cost : 0;
				existing.subtotal = this.currentPieces * p
			}else{
				// Se crea linea de venta para orden
				var sale_line = new SaleLine()
				sale_line.product_id = this.currentProduct.product_id
				sale_line.product_name = this.currentProductName
				sale_line.product_type = this.currentProduct.product_type
				sale_line.pieces = this.currentPieces
				sale_line.time_minutes = this.currentProduct.product_time_minutes
				let p = (this.currentProduct) ? this.currentProduct.product_subsidiary_cost : 0;
				sale_line.price = this.fixedFormat(p, 2)
				sale_line.subtotal = this.currentPieces * p
				// Se agrega información de producto a lineas de venta
				this.orderLines.push(sale_line)
			}
			// Se actualizan valores y se cierra modal
			this.updateTotalOrder();
			this.closeSelectProduct();
		}
	},
	updateProductUI(){
		if(!this.currentProduct){
			return
		}
		this.currentAmount = Math.max(this.currentProduct.product_subsidiary_cost * this.currentPieces, 0)
		this.formattedAmount = this.fixedFormat(this.currentAmount, 2)
	},
	updateTotalOrder(){
		var total = 0
		this.orderLines.forEach(line => {
			total = total + line.subtotal
		});
		this.totalOrder = total
	},
	countDownAlertChangedCustomerSelect(dismissCountDown) {
		this.dismissCountDownAlertCustomerSelect = dismissCountDown
	},
	onRowCustomerSelected(items) {
		// Se asigna información de cliente seleccionado
		items.forEach(info => {
			this.currentRegisterClient = info;
		});
	},
	countDownAlertChangedCustomerRegister(dismissCountDown) {
		this.dismissCountDownAlertCustomerRegister = dismissCountDown
	},
	confirmNoRegistrationCustomer(){
		if(this.customersNameValid && this.customersPhoneValid){
			// this.randomNumber = Math.floor(Math.random()*(101))
			// Nombre(s) y teléfono(s) de clientes no registrados
			this.nameClients = this.customersName
			this.phoneClients = this.customersPhone
			this.activeCustomer = true
			this.$refs['modal-no-register-client'].hide();
		}else{
			this.warningNotif('ATENCIÓN:', '¡Valida los datos requeridos!')
		}
	},
	async confirmRegistrationCustomer(){
		if(this.customerRegisterNameValid && this.customerRegisterLastNameValid && this.customerRegisterPhoneValid){

			//this.showLoader("Guardando información de nuevo cliente ...")
			// Se almacena registro de cliente
			const customer_register_info = {
				Customer : {
					name: this.customerRegisterName,
					last_name: this.customerRegisterLastName,
					email: this.customerRegisterMail,
					phone_number: this.customerRegisterPhone,
					birthdate: this.customerBirthdate,
					created_by_user_id: this.user.id,
					updated_by_user_id: this.user.id
				}
			}

			const res = await this.xpost("/api/register_customer_info", customer_register_info);
			//this.stopLoader()

			if(res.success){
				let customer_register = res.data.customer_register
				this.successNotif("¡Registrado Exitosamente!", customer_register.name + " " + customer_register.last_name)
				await this.getCustomersRegister()
				this.$refs['modal-register-client'].hide()
			}
			else {
				this.errorNotifDialog("Ha ocurrido un error con al registrar cliente.", res.error)
			}
		}else{
			this.warningNotif('ATENCIÓN:', '¡Valida los datos requeridos!')
		}
	},
	formatPhone(e){
		return String(e).substring(0,10);
	},
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    validEmail(email){
        var re = /(.+)@(.+){2,}\.(.+){2,}/;
        return re.test(email.toLowerCase());
    },
	cancelNoRegistrationCustomer(){
		this.$refs['modal-no-register-client'].hide();
	},
	cancelRegistrationCustomer(){
		this.$refs['modal-register-client'].hide();
	},
	cancelSelectCustomer(){
		this.$refs['modal-select-client'].hide();
	},
	confirmSelectCustomer(){
		this.nameClients = this.currentRegisterClient.customer_register_name + ' ' + this.currentRegisterClient.customer_register_last_name
		this.phoneClients = this.currentRegisterClient.customer_register_phone
		this.activeCustomer = true
		this.$refs['modal-select-client'].hide();
	},
    deleteProductRequest(id){
		//let mssg = "¿Desea quitar el producto de su venta?";
		//this.confirmationDialog(this.doDeleteProduct, "Confirmar", mssg, "Eliminar");
		this.doDeleteProduct(id);
    },
	doDeleteProduct(id){
		this.orderLines = this.orderLines.filter(f => f.product_id != id)
		this.updateTotalOrder();
	},
	editProductRequest(id) {
		let product = this.productsBySubsidiary.find(f => f.product_id === id)
		this.onProductAction(product)
	},
	cancelOrder(){
		// Se limpia info de cliente activo
		this.cleanClientInfo()
		this.activeCustomer = false
		// Se limpian lineas de venta
		this.orderLines = []
		this.totalOrder = null
	},
	cleanClientInfo(){
		this.nameClients = null
		this.phoneClients = null
		//this.randomNumber = 0
	},
	cleanCustomerRegisterInfo(){
		this.customerRegisterName = ''
		this.customerRegisterLastName = ''
		this.customerRegisterMail = ''
		this.customerRegisterPhone = ''
		this.customerBirthdate = ''
	},
	async confirmOrder(){

		this.extraMinutesToPay = false

		// Si existe un cliente activo 
		if(this.activeCustomer){
			// Si hay productos agregados a la orden
			if(this.orderLines.length > 0){
				// Se revisa configuración de sucursal
				this.checkPosConfigsSubsidiary()
				// Si es consumo de tiempo libre
				let freeTimeOnOrder = this.validateFreeTimeOnOrder()
				if(freeTimeOnOrder){
					this.freeTimeOrderStored = false
					// Se crea venta y renta de tiempo libre
					await this.registerSaleFreeTime()
					// Si se registra venta de tiempo libre se genera ticket inicial
					if(this.freeTimeOrderStored){
						// Se notifica al cliente
						this.successNotif("TIEMPO LIBRE:", '¡Registrado Exitosamente!')
						// Ticket inicial
						await this.getTicketFreeTimeInit()
						// Se limpian datos de orden
						this.cancelOrder()
					}
				}else{
					// Si es venta normal se pide método de pago
					this.openSelectPaymentMethod()
				}
			}
		}
	},
	validateFreeTimeOnOrder(){
		let freeTimeExist = false
		// Se recorren lineas de venta buscando tiempo libre
        this.orderLines.forEach(line => {
			if (line.product_type === 'TIEMPO LIBRE'){
				freeTimeExist = true
			}
        });
		return freeTimeExist
	},
	openSelectPaymentMethod(){
		// Se indica que es renta normal
		this.rentType = 'NORMAL'
		// Se coloca EFECTIVO como forma de pago predeterminada
		this.paymentMethodSelected = 1
		this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
		// Se colocan valores para pago en efectivo
		this.cashPayment = this.totalOrder
		this.formattedAmountTotal = this.fixedFormat(this.totalOrder,2)
		this.formattedAmountReturn = this.fixedFormat(0, 2)
		// Se abre modal de forma de pago
		this.$refs['modal-payment-method'].show();
	},
	closeSelectPaymentMethod(){
		this.$refs['modal-payment-method'].hide();
	},
	updateCashAmounts(){
		// Se calcula cambio
		let return_cash = this.cashPayment - this.totalOrder
		this.formattedAmountReturn = this.fixedFormat(return_cash, 2)
	},
	updateAmountFreeOrder(){
		let totalFreeOrder = 0
		let ProductToFreeOrder = this.productsToFreeOrder.find(f => f.product_id === this.productToFreeOrderSelected)
		if(ProductToFreeOrder){
			totalFreeOrder = parseInt(this.qtyProductsToFreeOrder) * parseInt(ProductToFreeOrder.product_subsidiary_cost)
		}
		this.amountFreeOrder = totalFreeOrder
		this.formattedAmountFreeOrder = this.fixedFormat(totalFreeOrder, 2)
	},
	checkPosConfigsSubsidiary(){
		// Se valida si la sucursal tiene configurado doble tiempo
		let dobleTiempoActivo = this.configsSubsidiaryInfo.find(conf => conf.pos_config_name === "DOBLE_TIEMPO")?true:false
		// Si esta activado, se revisa si es lunes o martes para aplicar
		if(dobleTiempoActivo){
			var today = new Date()
			let today_day = today.getDay()
			// Si es lunes (1) o Martes (2) se aplica doble tiempo
			this.dobleTiempo = (today_day === 1 || today_day === 2)?true:false
		}
	},
	async confirmPaymentMethodSelection(){

		// Se cierra forma de pago para evitar más peticiones
		this.closeSelectPaymentMethod()

		if (this.extraMinutesToPay){

			let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === this.rentCarId)
			if (existing_rentOperation){
				// Se registra información de tiempo adicional
				let end_time_extra_min = new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
				this.infoUpdated = false
				await this.updateInfoByExtraMinutes(this.rentCarId, this.costMinExtra, this.qtyMinExtra, this.totalMinExtra)

				// Si se actualiza la información, eliminamos tarjeta y se cierra la forma de pago
				if(this.infoUpdated){
					// Se elimina tarjeta de renta 
					this.cleanRentOperation(this.rentCarId)
					// Se cierra forma de pago
					//this.closeSelectPaymentMethod()
					// Se notifica al usuario
					this.successNotif("CLIENTE:", '¡Tiempo finalizado correctamente!')
					// Se genera ticket de minutos extras
					await this.getTicketMinExtras(existing_rentOperation.rentNames, existing_rentOperation.rentInitTime, existing_rentOperation.rentEndTime,
												 end_time_extra_min, this.qtyMinExtra, this.totalMinExtra)
					// Se limpian datos de orden
					this.cancelOrder()
				}
			}

		}else{

			// Si viene de TIEMPO LIBRE
			if(this.rentType === 'FREE_TIME'){
				let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === this.rentFreeTimeId)
				if (existing_rentOperation){

					// Se evalua total en rangos de minutos que será multiplicado por la cantidad desde el back
					let amountTotalFreeTime = this.getTotalAmountFreeTime(existing_rentOperation.rentTime)
					// Tiempo final de tiempo libre
					let end_time_free_time = new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
					// Se actualiza información de venta
					this.infoUpdated = false
					await this.updateInfoByFreeTime(existing_rentOperation.sale_id, existing_rentOperation.operation_id, 
													end_time_free_time, existing_rentOperation.rentTime, amountTotalFreeTime)

					// Si se actualiza la información, eliminamos tarjeta y se cierra la forma de pago
					if(this.infoUpdated){
						// Se elimina tarjeta de renta 
						this.cleanRentOperation(this.rentFreeTimeId)
						// Se cierra forma de pago
						//this.closeSelectPaymentMethod()
						// Se notifica al usuario
						this.successNotif("CLIENTE:", '¡Tiempo finalizado correctamente!')
						// Se genera ticket de tiempo libre
						await this.getTicketFreeTime(existing_rentOperation.rentNames, existing_rentOperation.rentInitTime, end_time_free_time)
						// Se limpian datos de orden
						this.cancelOrder()
					}
				}
			}

			// Si viene de TIEMPO NORMAL
			if(this.rentType === 'NORMAL'){

				this.normalOrderStored = false
				// Se registra información de venta
				await this.registerSale()

				// Si se crea la venta, lineas de venta y operación se genera ticket
				if(this.normalOrderStored){
					// Se notifica al usuario
					this.successNotif("CLIENTE:", '¡Venta registrada correctamente!')
					// Se imprime ticket
					await this.getTicketNormalSale()
					// Se limpian datos de orden
					this.cancelOrder()
				}
			}

		}
	},
	setLinesbySaleInfo(rawLines){
		this.orderLinesFreeTime = [];
		rawLines.forEach(line => {
			// Se crea linea de venta para orden
			var sale_line = new SaleLine()
			sale_line.product_id = line.product_id
			sale_line.pieces = line.quantity
			sale_line.price = line.product_cost
			sale_line.subtotal = line.sale_line_total
			// Se agrega información de producto a lineas de venta
			this.orderLinesFreeTime.push(sale_line);
		});
	},
	async registerSale(){

		//this.showLoader("Guardando información de venta ...")
		
		let venta = {}
		let detalles_venta = []

		// Venta
		venta.sale_total = this.totalOrder
		venta.user_id = this.user.id
		venta.subsidiary_id = this.user.meta_info.subsidiary_id

		// Lineas de venta
        this.orderLines.forEach(line => {
          const obj = {
            quantity: line.pieces,
            product_id: line.product_id,
            product_cost: line.price,
            sale_line_total: line.subtotal
          }
          detalles_venta.push(obj)
        });

       	venta.sale_line_attributes = detalles_venta

		// Información de renta / operación
		let operationInfo = this.getOperationInfo()

		// Información de pago
		let payment_info = {}
		payment_info.amount_total = this.totalOrder
		payment_info.amount_received = this.cashPayment
		payment_info.cash_change = this.cashPayment - this.totalOrder
		payment_info.payment_method_id = this.paymentMethodSelected
	
		const payload = {
			Sale: venta,
			Operation: operationInfo,
			Payment: payment_info
		}

		const res = await this.xpost("/api/purchase", payload);
		//this.stopLoader()

		if(res.success){
			let operation = res.data.operation
			let consecutive_sale = res.data.consecutive_sale
			this.createRentLine(operation, consecutive_sale)
			this.normalOrderStored = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al registrar la venta.", res.error)
		}

		//this.closeSelectPaymentMethod()

	},
	async registerSaleFreeTime(){
		//this.showLoader("Guardando información de venta ...")
		
		let venta = {}
		let detalles_venta = []

		// Venta
		venta.sale_total = this.totalOrder
		venta.user_id = this.user.id
		venta.subsidiary_id = this.user.meta_info.subsidiary_id

		// Lineas de venta
        this.orderLines.forEach(line => {
          const obj = {
            quantity: line.pieces,
            product_id: line.product_id,
            product_cost: line.price,
            sale_line_total: line.subtotal
          }
          detalles_venta.push(obj)
        });

       	venta.sale_line_attributes = detalles_venta

		// Información de renta / operación
		let operationInfo = this.getOperationInfoFreeTime()
	
		const payload = {
			Sale: venta,
			Operation: operationInfo
		}

		const res = await this.xpost("/api/purchase", payload);
		//this.stopLoader()

		if(res.success){
			let operation = res.data.operation
			let consecutive_sale = res.data.consecutive_sale
			this.createRentLineFreeTime(operation, consecutive_sale)
			this.freeTimeOrderStored = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al registrar la venta.", res.error)
		}

		//this.closeSelectPaymentMethod()

	},
	async registerSaleLine(quantity, product_id, product_cost, sale_line_total, sale_id){

		//this.showLoader("Guardando información de linea de venta ...")
		
		const data = {
			quantity: quantity,
			product_id: product_id,
			product_cost: product_cost,
			sale_line_total: sale_line_total,
			sale_id: sale_id
		}

		// Información de método de pago
		let payment_info = {}
		payment_info.payment_method_id = this.paymentMethodSelected

		const info = {
			Line: data,
			Payment_Method: payment_info
		}
		const res = await this.xpost("/api/purchase_line", info);

		if(res.success){
			this.saleLineStored = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al registrar venta de tiempo adicional.", res.error)
		}

		//this.stopLoader()

	},
	async registerFreeOrder(quantity, product_id, product_cost, sale_line_total){

		//this.showLoader("Guardando información de linea de venta ...")
		
		const data = {
			quantity: quantity,
			product_id: product_id,
			product_cost: product_cost,
			sale_line_total: sale_line_total,
			subsidiary_id: this.user.meta_info.subsidiary_id,
			user_id: this.user.id,
			payment_method_id: this.paymentMethodSelected
		}

		const res = await this.xpost("/api/purchase_free_order", data);

		if(res.success){
			this.freeOrderStored = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al registrar venta libre.", res.error)
		}

		//this.stopLoader()

	},
	async updateOperationSaleForAddingTime(sale_id, operation_id, new_end_time, minutesAcumulated){

		//this.showLoader("Actualizando operación ...")
		
		const info = {
			sale_id: sale_id,
			operation_id: operation_id,
			new_end_time: new_end_time,
			new_minutes_used: minutesAcumulated
		}

		const res = await this.xpost("/api/update_operation", info);

		if(res.success){
			this.infoUpdated = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al actualizar la operación por tiempo adicional.", res.error)
		}

		//this.stopLoader()

	},
	async updateInfoByFreeTime(sale_id, operation_id, new_end_time, minutesAcumulated, costFreeTime){

		//this.showLoader("Actualizando operación ...")
		
		const info = {
			sale_id: sale_id,
			operation_id: operation_id,
			new_end_time: new_end_time,
			new_minutes_used: minutesAcumulated,
			cost: costFreeTime,
			user_id: this.user.id,
			// Información de pago
			payment_amount_total: costFreeTime,
			payment_amount_received: this.cashPayment,
			payment_cash_change: this.cashPayment - costFreeTime,
			payment_method_id: this.paymentMethodSelected
		}

		const res = await this.xpost("/api/update_info_free_time", info);

		if(res.success){
			this.setLinesbySaleInfo(res.data.sale_lines)
			this.totalTicketFreeTime = res.data.sale.sale_total
			this.infoUpdated = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al actualizar la operación por tiempo libre", res.error)
		}

		//this.stopLoader()

	},
	async updateInfoByExtraMinutes(operation_id, costMinExtra, qtyMinExtra, totalMinExtra){

		//this.showLoader("Actualizando operación ...")
		
		const info = {
			operation_id: operation_id,
			cost_min_extra: costMinExtra,
			qty_min_extra: qtyMinExtra,
			total_min_extra: totalMinExtra,
			user_id: this.user.id,
			// Información de pago
			payment_amount_total: totalMinExtra,
			payment_amount_received: this.cashPayment,
			payment_cash_change: this.cashPayment - totalMinExtra,
			payment_method_id: this.paymentMethodSelected
		}

		const res = await this.xpost("/api/update_info_extra_minutes", info);

		if(res.success){
			this.infoUpdated = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al actualizar la operación por minutos extras", res.error)
		}

		//this.stopLoader()

	},
	getOperationInfo(){
		// Se redondea el tiempo de inicio al múltiplo de 5 más cercano
		var time_ini = new Date()
		var time_end = time_ini
		var residuoMin = time_ini.getMinutes()%5
		let diffMin = 5 - residuoMin
		time_ini.setMinutes(time_ini.getMinutes() + diffMin)
		let init_time = time_ini.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })

		// Se obtiene tiempo final
		let minsToAdd = this.getTimeToRent()
		time_end.setMinutes(time_end.getMinutes() + minsToAdd)
		let end_time = time_end.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })

		// Se asigna cliente registrado (si aplica)
		var customer_id = null
		if(this.currentRegisterClient){
			customer_id = this.currentRegisterClient.customer_register_id
		}

		// Tiempos para ticket
		this.initTimeTicket = init_time
		this.endTimeTicket = end_time

		const operationInfo = {
			start_time: init_time,
			end_time: end_time,
			minutes_used: minsToAdd,
			customer_register_id: customer_id,
			item_id: null,
			names: this.nameClients,
			phone: this.phoneClients,
			rent_type: 'NORMAL'
		}

		return operationInfo
	},
	getOperationInfoFreeTime(){
		// Se redondea el tiempo de inicio al múltiplo de 5 más cercano y solo se obtiene tiempo inicial
		var time_ini = new Date()
		var residuoMin = time_ini.getMinutes()%5
		let diffMin = 5 - residuoMin
		time_ini.setMinutes(time_ini.getMinutes() + diffMin)
		let init_time = time_ini.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })

		// Se almacena tiempo para ticker inicial
		this.initTimeTicket = init_time

		// Se asigna cliente registrado (si aplica)
		var customer_id = null
		if(this.currentRegisterClient){
			customer_id = this.currentRegisterClient.customer_register_id
		}

		const operationInfo = {
			start_time: init_time,
			//end_time: end_time,
			minutes_used: 0,
			customer_register_id: customer_id,
			item_id: null,
			names: this.nameClients,
			phone: this.phoneClients,
			rent_type: 'FREE_TIME'
		}

		return operationInfo
	},
	getTimeToRent(){
		var minsToAdd = 0
		// Lineas de venta
        this.orderLines.forEach(line => {
			// Si no es tiempo libre
			if(line.product_type !== "TIEMPO LIBRE"){
				// Se suman productos de TIEMPO
				if(line.product_type.indexOf("TIEMPO") === 0){
					// DUMMY para extracción de tiempo
					//var time_product = parseInt(line.product_name.substring(0,3))
					var time_product = parseInt(line.time_minutes)
					// Si aplica doble tiempo
					if(this.dobleTiempo){
						time_product = time_product * 2
					}
					minsToAdd = minsToAdd + time_product
				}
			}
        });

		return minsToAdd
	},
	createRentLine(sale_operation, actual_sale_consecutive){

		/*
		// Se valida existencia de operación
		let existing_operation = this.getRentOperations().find(f => f.operation_id === sale_operation.id)

		// Se refresca tarjeta en state, eliminando y creando nuevamente
		if (existing_operation){
			this.cleanRentOperation(existing_operation.operation_id)
		}
		*/

		// Se crea tarjeta con información de productos que generen una renta y esta 'ACTIVA'
		var rent_line = new RentLine()
		rent_line.operation = sale_operation
		rent_line.operation_id = sale_operation.id
		rent_line.sale_id = sale_operation.sale_id
		rent_line.rentNumber = actual_sale_consecutive
		rent_line.rentNames = sale_operation.names
		rent_line.phoneNumber = sale_operation.phone
		rent_line.rentType = sale_operation.rent_type

		// Si es TIEMPO LIBRE no se asignan end times ni minutos por usar
		if(sale_operation.rent_type === 'FREE_TIME'){
			// Se agrega formato a fechas obtenidas
			let init_time = new Date(sale_operation.start_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			rent_line.rentInitTime = init_time
			//let end_time = new Date(sale_operation.end_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			//rent_line.rentEndTime = end_time
			rent_line.rentTime = 0
		}

		// Si es TIEMPO NORMAL se asignan end times y minutos por usar
		if(sale_operation.rent_type === 'NORMAL'){
			// Se agrega formato a fechas obtenidas
			let init_time = new Date(sale_operation.start_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			rent_line.rentInitTime = init_time
			let end_time = new Date(sale_operation.end_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			rent_line.rentEndTime = end_time
			rent_line.rentTime = parseInt(sale_operation.minutes_used)
		}

		// Se almacena en state las operaciones
		this.setRentOperation(rent_line)

	},
	createRentLineFreeTime(sale_operation, actual_sale_consecutive){
		// Se valida existencia de operación
		let existing_operation = this.getRentOperations().find(f => f.operation_id === sale_operation.id)
		if (!existing_operation){
			// Se agrega información de productos que generen una renta
			var rent_line = new RentLine()
			rent_line.operation = sale_operation
			rent_line.operation_id = sale_operation.id
			rent_line.sale_id = sale_operation.sale_id
			rent_line.rentNumber = actual_sale_consecutive
			rent_line.rentNames = sale_operation.names
			rent_line.phoneNumber = sale_operation.phone
			rent_line.rentType = sale_operation.rent_type
			// Se agrega formato a fechas obtenidas
			let init_time = new Date(sale_operation.start_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			rent_line.rentInitTime = init_time
			//let end_time = new Date(sale_operation.end_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
			//rent_line.rentEndTime = end_time
			rent_line.rentTime = 0
			// Se almacena en state las operación
			this.setRentOperation(rent_line)
		}
	},
	cancelPaymentMethodSelection(){
		this.closeSelectPaymentMethod()
	},
	async onAddTimeAction(rent_id){

		let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === rent_id)
		if (existing_rentOperation){

			// Brincolines
			if (this.getUserSubsidiary.subsidiary_trade === 'Brincolines'){
				// Si no es tiempo libre
				if(existing_rentOperation.rentType !== 'FREE_TIME'){
					// Se obtiene renta en cuestión
					this.addTimeRentId = rent_id
					// Se obtienen productos para tiempo adicional (No tiempo libre)
					let productsSubsidiary = this.getProductsSubsidiary
					this.productsToAddTime = productsSubsidiary.filter(f => (f.product_type === 'TIEMPO BRINCOLIN') || (f.product_type === 'TIEMPO TREN') || (f.product_type === 'TIEMPO MODULAR'))
					// Se escoge primer producto del listado
					if(this.productsToAddTime.length > 0){
						this.productToAddTimeSelected = this.productsToAddTime[0].product_id
						this.productsToAddTimeName = this.productsToAddTime[0].product_name
						this.qtyTimeMinutesProduct = this.productsToAddTime[0].product_time_minutes
						this.priceTimeMinutesProduct = this.productsToAddTime[0].product_subsidiary_cost
					}
					// Se inicializa cantidad en 1
					this.qtyCustomersToAddTime = 1
					// Efectivo
					this.paymentMethodSelected = 1
					this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
					this.$refs['modal-addtime-rent'].show();
				}else{
					this.warningNotif('ATENCIÓN:', '¡No puedes adicionar tiempo ya que es libre!')
				}
			}

			// Carritos
			if (this.getUserSubsidiary.subsidiary_trade === 'Carritos'){
				// Se obtiene renta en cuestión
				this.addTimeRentId = rent_id
				// Se obtienen productos para tiempo adicional
				let productsSubsidiary = this.getProductsSubsidiary
				this.productsToAddTime = productsSubsidiary.filter(f => (f.product_type === 'TIEMPO CARRITOS') || (f.product_type === 'TIEMPO TREN') || (f.product_type === 'TIEMPO MODULAR'))
				// Se escoge primer producto del listado
				if(this.productsToAddTime.length > 0){
					this.productToAddTimeSelected = this.productsToAddTime[0].product_id
					this.productsToAddTimeName = this.productsToAddTime[0].product_name
					this.qtyTimeMinutesProduct = this.productsToAddTime[0].product_time_minutes
					this.priceTimeMinutesProduct = this.productsToAddTime[0].product_subsidiary_cost
				}
				// Se inicializa cantidad en 1
				this.qtyCustomersToAddTime = 1
				// Efectivo
				this.paymentMethodSelected = 1
				this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
				this.$refs['modal-addtime-rent'].show();
			}
		}	
	},
    onChangeProductToAddTime: function(event) {
		let productToAddTime = this.productsToAddTime.find(f => f.product_id === this.productToAddTimeSelected)
		if(productToAddTime){
			this.productsToAddTimeName = productToAddTime.product_name
			this.qtyTimeMinutesProduct = productToAddTime.product_time_minutes
			this.priceTimeMinutesProduct = productToAddTime.product_subsidiary_cost
		}
    },
	async confirmAddTimeToRent(){
		if(!this.qtyCustomersToAddTime || this.qtyCustomersToAddTime <= 0){
			this.warningNotif('ATENCIÓN:', '¡Ingresa una cantidad de clientes válida!')
			this.$refs['modal-addtime-rent'].hide();
		}else{
			// Se cierra modal para evitar más peticiones
			this.$refs['modal-addtime-rent'].hide();
			await this.addTimeToOperation()
		}
	},
	async addTimeToOperation(){

		// Se obtiene renta para actualizar tiempo final
		let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === this.addTimeRentId)

		if (existing_rentOperation){

			this.operationStored = null
			// Se obtiene información almacenada de operación
			await this.getOperationInfoStored(this.addTimeRentId)

			if (this.operationStored !== null){

				// Minutos del producto seleccionado
				var minutesToAdd = parseInt(this.qtyTimeMinutesProduct)
				// Si aplica doble tiempo
				if(this.dobleTiempo){
					minutesToAdd = minutesToAdd * 2
				}
				// Se obtiene tiempo final y minutos acumulados con tiempo añadido
				let end_time = new Date()
				end_time.setHours(this.operationStored.end_time.substring(11,13), 
								  this.operationStored.end_time.substring(14,16),
								  this.operationStored.end_time.substring(17,19))

				let end_date_orig = existing_rentOperation.rentEndTime
				let minutes_used_orig = existing_rentOperation.operation.minutes_used

				// Se acumula tiempo original y el añadido
				let minutesAcumulated = minutesToAdd + parseInt(this.operationStored.minutes_used)
				// Se añaden minutos adicionales
				end_time.setMinutes(end_time.getMinutes() + minutesToAdd)
				// Se obtiene nueva hora fin
				let new_end_time = end_time.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false })
				// Nueva hora fin
				existing_rentOperation.rentEndTime = new_end_time
				existing_rentOperation.operation.end_time = new_end_time
				// Nuevos minutos a consumir
				existing_rentOperation.rentTime = minutesAcumulated
				existing_rentOperation.operation.minutes_used = minutesAcumulated

				this.saleLineStored = false
				// Se genera linea de venta
				await this.registerSaleLine(this.qtyCustomersToAddTime, this.productToAddTimeSelected, this.priceTimeMinutesProduct, 
											(this.qtyCustomersToAddTime * this.priceTimeMinutesProduct), existing_rentOperation.sale_id)

				// Si se almacena linea de venta, actualizamos información
				if(this.saleLineStored){
					this.infoUpdated = false
					// Se actualiza operación y monto de venta
					await this.updateOperationSaleForAddingTime(existing_rentOperation.sale_id, existing_rentOperation.operation_id,
																new_end_time, minutesAcumulated)
				}else{
					// Hora fin existente
					existing_rentOperation.rentEndTime = end_date_orig
					existing_rentOperation.operation.end_time = end_date_orig
					// Minutos a consumir existentes
					existing_rentOperation.rentTime = minutes_used_orig
					existing_rentOperation.operation.minutes_used = minutes_used_orig
				}

				// Si se almacena la linea de venta y se actualiza información
				if(this.saleLineStored && this.infoUpdated){
					// Se notifica al usuario
					this.successNotif("TIEMPO ADICIONAL:", '¡Registrado Exitosamente!')
					// Se genera ticket de tiempo adicional
					await this.getTicketAddedTime(existing_rentOperation.rentNames, existing_rentOperation.rentInitTime, end_date_orig,
													new_end_time, this.qtyCustomersToAddTime, this.productsToAddTimeName,
													this.fixedFormat(this.priceTimeMinutesProduct, 2),  
													this.fixedFormat((this.qtyCustomersToAddTime * this.priceTimeMinutesProduct), 2))
				}

			}else{
				this.warningNotif('ATENCIÓN:', '¡No se puede obtener información de operación!')
			}
		}
	},
	async getOperationInfoStored(operation_id){

		//this.showLoader("Guardando información de incidente ...")

		const res = await this.xget("/api/operation_info/"+operation_id);

		if(res.success){
			this.operationStored = res.data.operation
		}
		else {
			this.operationStored = null
			this.errorNotifDialog("Ha ocurrido un error al obtener información de operación.", res.error)
		}

		//this.stopLoader()

	},
	cancelAddTimeToRent(){
		this.$refs['modal-addtime-rent'].hide();
	},
	async onIncidentAction(rent_id){
		// Se obtiene renta en cuestión
		this.incidentRentId = rent_id
		// Se inicializan valores
		this.incidentCommentToRegister = ''
		this.incidentAmountToRegister = 1
		this.$refs['modal-register-incident'].show();
	},
	async confirmRegisterIncident(){
		if(!this.incidentAmountToRegister || this.incidentAmountToRegister <= 0){
			this.warningNotif('ATENCIÓN:', '¡Ingresa un monto válido!')
		}else if(this.incidentCommentToRegister === ''){
			this.warningNotif('ATENCIÓN:', '¡Ingresa un comentario válido!')
		}else{
			await this.registerIncident( this.incidentCommentToRegister, this.incidentAmountToRegister, this.incidentRentId);
		this.$refs['modal-register-incident'].hide();
		}
	},
	cancelRegisterIncident(){
		this.$refs['modal-register-incident'].hide();
	},
	async registerIncident(incident_comments, incident_amount, operation_id){

		//this.showLoader("Guardando información de incidente ...")
		
		const info = {
			comments: incident_comments,
			amount_refunded: incident_amount,
			operation_id: operation_id
		}

		const data = {
			Incident: info
		}

		const res = await this.xpost("/api/register_incident_info", data);

		if(res.success){
			this.successNotif("INCIDENCIA:", '¡Registrada Exitosamente!')
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al registrar incidencia.", res.error)
		}

		//this.stopLoader()

	},
	async onCloseRentAction(rent_id){
		this.closingRentID = rent_id
		// Confirmación de eliminación de tarjeta		
		let mssg = "¿Deseas finalizar el tiempo?";
    	this.confirmationDialog(this.doCloseRentAction, "Finalizar tarjeta", mssg, "Confirmar");
	},
	async doCloseRentAction() {

		this.extraMinutesToPay = false

		// Se obtiene renta para validar finalización
		const rent_id = this.closingRentID
		let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === rent_id)
		if (existing_rentOperation){

			// Brincolines
			if (this.getUserSubsidiary.subsidiary_trade === 'Brincolines'){

				// Si es TIEMPO LIBRE
				if(existing_rentOperation.rentType === 'FREE_TIME'){
					// Se indica id de renta
					this.rentFreeTimeId = existing_rentOperation.operation_id
					this.openSelectPaymentMethodFreeTime(existing_rentOperation.rentTime)
				}else{
					// Se valida que el tiempo restante no sea mayor a -5 minutos, ya que de lo contrario deben agregar tiempo
					if(existing_rentOperation.rentTime < -5){
						this.warningNotif('ATENCIÓN:', '¡Debes agregar tiempo adicional para poder realizar cierre!')
					}else{
						this.infoUpdated = false
						// Se actualiza venta, lineas de venta y operación
						await this.updateSaleLinesOperation(existing_rentOperation.sale_id, existing_rentOperation.operation_id);
						// Si se actualiza la información, eliminamos tarjeta
						if(this.infoUpdated){
							// Se elimina tarjeta de renta 
							this.cleanRentOperation(rent_id)
						}
					}
				}
			}

			// Carritos
			if (this.getUserSubsidiary.subsidiary_trade === 'Carritos'){

				// Se obtiene tiempo de tolerancia para entregar carritos
				let tolerance_min = 2
				tolerance_min = this.configsSubsidiaryInfo.find(conf => conf.pos_config_name === "TOLERANCIA_MINUTOS").pos_config_value
				tolerance_min = parseInt(tolerance_min * -1)

				// Si excede la tolerancia se cobra adicional
				if(existing_rentOperation.rentTime < tolerance_min){

					this.productsObtained = false
					// Se obtienen productos rentados
					await this.getLinesBySale(existing_rentOperation.sale_id)
					if(this.productsObtained){

						let min_extra_cost = 3
						let qty_min_extra = 1

						// Se recorre listado de productos
						this.linesBySale.forEach(line => {

							// Si es carrito de un niño
							if(line.product_type === "TIEMPO CARRITOS" && !line.product_name.includes("x 2")){
								min_extra_cost = this.configsSubsidiaryInfo.find(conf => conf.pos_config_name === "COSTO_MIN_ADICIONAL_UNO").pos_config_value
							}
							// Si es carrito de 2 niños
							if(line.product_type === "TIEMPO CARRITOS" && line.product_name.includes("x 2")){
								min_extra_cost = this.configsSubsidiaryInfo.find(conf => conf.pos_config_name === "COSTO_MIN_ADICIONAL_DOS").pos_config_value
							}
						});

						this.costMinExtra = min_extra_cost
						qty_min_extra = parseInt((parseInt(existing_rentOperation.rentTime) + parseInt(tolerance_min * -1)) * -1)
						this.qtyMinExtra = qty_min_extra
						this.totalMinExtra = qty_min_extra * parseInt(min_extra_cost)
						
						// Se solicita pago de minutos adicionales
						this.openSelectPaymentMethodCars(this.totalMinExtra, existing_rentOperation.operation_id)

					}

				// Se cierra tarjeta de tiempo
				}else{
					this.infoUpdated = false
					// Se actualiza venta, lineas de venta y operación
					await this.updateSaleLinesOperation(existing_rentOperation.sale_id, existing_rentOperation.operation_id);
					// Si se actualiza la información, eliminamos tarjeta
					if(this.infoUpdated){
						// Se elimina tarjeta de renta 
						this.cleanRentOperation(rent_id)
					}
				}
			}
		}
	},
	async getLinesBySale(sale_id){
		const res = await this.xget('/api/lines_by_sale/'+sale_id);
		if(res.success){
			this.setLinesBySale(res.data)
			this.productsObtained = true
		}else {
			this.errorNotifDialog("Ha ocurrido un error al obtener información de líneas de venta.", res.error)
		}
	},
	setLinesBySale(lines){
		this.linesBySale = [];
		lines.forEach(line => {
			var sale_line = {
					qty: line.qty, 
					product_id: line.product_id, 
					product_name: line.product_name, 
                    product_type: line.product_type, 
					cost: line.cost,
					total: line.total
			}
			this.linesBySale.push(sale_line);
		});
	},
	openSelectPaymentMethodCars(total_extra_cost, rent_id){
		this.rentCarId = rent_id
		// Se coloca EFECTIVO como forma de pago predeterminada
		this.paymentMethodSelected = 1
		this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
		// Se colocan valores para pago en efectivo
		let amountTotalExtraMin = parseInt(total_extra_cost)
		this.totalOrder = amountTotalExtraMin
		this.cashPayment = amountTotalExtraMin
		this.formattedAmountTotal = this.fixedFormat(amountTotalExtraMin, 2)
		this.formattedAmountReturn = this.fixedFormat(0, 2)
		this.extraMinutesToPay = true
		// Se abre modal de forma de pago
		this.$refs['modal-payment-method'].show();
	},
	openSelectPaymentMethodFreeTime(timeRentFreeTime){
		// Se coloca EFECTIVO como forma de pago predeterminada
		this.paymentMethodSelected = 1
		this.paymentMethodName= this.getPaymentMethodById(this.paymentMethodSelected).payment_method_name
		// Se evalua total en rangos de minutos
		let amountTotalFreeTime = this.getTotalAmountFreeTime(timeRentFreeTime)
		// Se colocan valores para pago en efectivo
		this.totalOrder = amountTotalFreeTime
		this.cashPayment = amountTotalFreeTime
		this.formattedAmountTotal = this.fixedFormat(amountTotalFreeTime, 2)
		this.formattedAmountReturn = this.fixedFormat(0, 2)
		// Se indica tipo de renta
		this.rentType = 'FREE_TIME'
		// Se abre modal de forma de pago
		this.$refs['modal-payment-method'].show();
	},
	getTotalAmountFreeTime(timeMinutes){

		// Se obtienen precios por sucursal
		let costRangeOne = this.getProductsSubsidiary.find(f => f.product_time_minutes === 15).product_subsidiary_cost
		let costRangeTwo = this.getProductsSubsidiary.find(f => f.product_time_minutes === 30).product_subsidiary_cost
		let costRangeThree = this.getProductsSubsidiary.find(f => f.product_time_minutes === 60).product_subsidiary_cost
		let costRangeFour = this.getProductsSubsidiary.find(f => f.product_time_minutes === 120).product_subsidiary_cost

		let amountTotal = 0
		amountTotal = (timeMinutes <= 15)?parseInt(costRangeOne):
						(timeMinutes > 15 && timeMinutes <=30)?parseInt(costRangeTwo):
							(timeMinutes > 30 && timeMinutes <=60)?parseInt(costRangeThree):
								(timeMinutes > 60 && timeMinutes <=75)?(parseInt(costRangeThree) + parseInt(costRangeOne)):
									(timeMinutes > 75 && timeMinutes <=90)?(parseInt(costRangeThree) + parseInt(costRangeTwo)):parseInt(costRangeFour)
		return amountTotal
	},
	async updateSaleLinesOperation(sale_id, operation_id){

		//this.showLoader("Guardando información de venta y operación ...")
		
		const info = {
			sale_id: sale_id,
			operation_id: operation_id,
			user_id: this.user.id
		}

		const res = await this.xpost("/api/update_sale_operation", info);

		if(res.success){
			this.successNotif("TIEMPO DE CLIENTE:", '¡Finalizado Exitosamente!')
			this.infoUpdated = true
		}
		else {
			this.errorNotifDialog("Ha ocurrido un error al actualizar información de venta y operación.", res.error)
		}

		//this.stopLoader()

	},
	async onPrintTicketAction(rent_id){
		// Información de operación
		let existing_rentOperation = this.getRentOperations().find(f => f.operation_id === rent_id)
		if (existing_rentOperation){
			// Información de venta
			await this.getLinesBySale(existing_rentOperation.sale_id)
			// Total de venta
			let total_ticket = 0
			this.linesBySale.forEach(line => {
				total_ticket = total_ticket + parseInt(line.total)
			});
			let end_time_ticket = existing_rentOperation.rentEndTime
			if(existing_rentOperation.rentEndTime === undefined){
				end_time_ticket = ""
			}
			// Se imprime ticket
			await this.getPrintTicket(existing_rentOperation.rentNames, existing_rentOperation.rentInitTime, end_time_ticket, this.linesBySale, this.fixedFormat(total_ticket,2))
		}
	},
	async getTicketNormalSale(){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+this.nameClients);
		a.document.write('<br><strong>ENTRADA: '+this.initTimeTicket+'</strong>');
		a.document.write('<br><strong>SALIDA: '+this.endTimeTicket+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');
		
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Lineas de venta
        this.orderLines.forEach(line => {
		  a.document.write('<tr>');
		  a.document.write('<td style="text-align: center;">'+line.pieces+'</td>');
		  a.document.write('<td>'+line.product_name+'</td>');
		  a.document.write('<td>$'+this.fixedFormat(line.subtotal,2)+'</td>');
		  a.document.write('</tr>');          
        });

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+this.fixedFormat(this.totalOrder,2)+'</td>');
		a.document.write('</tr>');  

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	},
	async getTicketAddedTime(nameClient, init_time, end_time, new_end_time, pieces, product_name, price, total){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+nameClient);
		a.document.write('<br><strong>ENTRADA: '+init_time+'</strong>');
		a.document.write('<br><strong>SALIDA: '+end_time+'</strong>');
		a.document.write('<br>Tiempo adicional');
		a.document.write('<br><strong>NUEVA SALIDA: '+new_end_time+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');
		
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Linea de venta
		a.document.write('<tr>');
		a.document.write('<td style="text-align: center;">'+pieces+'</td>');
		a.document.write('<td>'+product_name+'</td>');
		a.document.write('<td>$'+price+'</td>');
		a.document.write('</tr>');          

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+total+'</td>');
		a.document.write('</tr>');  

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	},
	async getTicketFreeTime(nameClient, init_time, end_time){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+nameClient);
		a.document.write('<br><strong>ENTRADA: '+init_time+'</strong>');
		a.document.write('<br><strong>SALIDA: '+end_time+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');
		
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Lineas de venta
        this.orderLinesFreeTime.forEach(line => {
		  a.document.write('<tr>');
		  a.document.write('<td style="text-align: center;">'+line.pieces+'</td>');

		  // Se obtiene producto
		  let product = this.productsBySubsidiary.find(f => f.product_id === line.product_id)
		  if(product){
		  	a.document.write('<td>'+product.product_name+'</td>');
		  }else{
		  	a.document.write('<td>'+'N/A'+'</td>');
		  }
		  a.document.write('<td>$'+line.subtotal+'</td>');
		  a.document.write('</tr>');          
        });        

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+this.totalTicketFreeTime+'</td>');
		a.document.write('</tr>');  

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	},
	async getTicketFreeTimeInit(){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+this.nameClients);
		a.document.write('<br><strong>ENTRADA: '+this.initTimeTicket+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
		
		//this.stopLoader()

	},
	async getTicketMinExtras(nameClients, init_time, end_time, end_time_extra_min, qty_min_extra, total_min_extra){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+nameClients);
		a.document.write('<br><strong>ENTRADA: '+init_time+'</strong>');
		a.document.write('<br><strong>SALIDA: '+end_time+'</strong>');
		a.document.write('<br>Minutos extras');
		a.document.write('<br><strong>NUEVA SALIDA: '+end_time_extra_min+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');
		
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Lineas de venta
		a.document.write('<tr>');
		a.document.write('<td style="text-align: center;">'+qty_min_extra+'</td>');
		a.document.write('<td>MINUTOS EXTRA</td>');
		a.document.write('<td>$'+total_min_extra+'</td>');
		a.document.write('</tr>');    
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+total_min_extra+'</td>');
		a.document.write('</tr>');

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	},
	async getTicketFreeOrder(pieces, product_name, total){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		a.document.write('<p></p>');
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Lineas de venta
		a.document.write('<tr>');
		a.document.write('<td style="text-align: center;">'+pieces+'</td>');
		a.document.write('<td>'+product_name+'</td>');
		a.document.write('<td>$'+total+'</td>');
		a.document.write('</tr>');        

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+total+'</td>');
		a.document.write('</tr>');

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	},
	async getPrintTicket(name_clients, init_time, end_time, lines, total){

		//this.showLoader("Descargando ticket...")

		// Ventana temporal de ticket
		var a = window.open('', '', 'height=600, width=250,, top=0, left=250');
		a.document.write('<html><body>');
		a.document.write('<div style="width: 240px; max-width: 240px;">');
		// Logo
		a.document.write('<img src="https://i.ibb.co/FqfdDFF/logo-brink-bn.png" alt="Logotipo" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		// Sucursal
		var subsidiaryName = this.getUserSubsidiary.subsidiary_name
		a.document.write('<p style="text-align: center; align-content: center;">'+subsidiaryName);
		// Hora del ticket
		var dateTicket = new Date()
		a.document.write('<p style="text-align: center; align-content: center;">'+dateTicket.toLocaleString()+'</p>');
		a.document.write('<p></p>');
		a.document.write('<p style="text-align: center; align-content: center;">Reimpresión de ticket');
		// Cliente
		a.document.write('<div>');
		a.document.write('<br>Visitante: '+name_clients);
		a.document.write('<br><strong>ENTRADA: '+init_time+'</strong>');
		a.document.write('<br><strong>SALIDA: '+end_time+'</strong>');
		a.document.write('</div>');
		a.document.write('<p></p>');		
		// Encabezado de lineas de venta
		a.document.write('<table><thead><tr><th>CANT.</th><th>DESCRIPCIÓN</th><th>$</th></tr></thead>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tbody>');

		// Lineas de venta
        lines.forEach(line => {
		  a.document.write('<tr>');
		  a.document.write('<td style="text-align: center;">'+line.qty+'</td>');
		  a.document.write('<td>'+line.product_name+'</td>');
		  a.document.write('<td>$'+line.total+'</td>');
		  a.document.write('</tr>');          
        });

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// Total
		a.document.write('<tr>');
		a.document.write('<td></td>');
		a.document.write('<td style="font-weight: bold;">TOTAL</td>');
		a.document.write('<td style="font-weight: bold;">$'+total+'</td>');
		a.document.write('</tr>');  

		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('</tbody></table>');
		a.document.write('<p style="text-align: center; align-content: center;">¡GRACIAS POR TU VISITA!</p>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		a.document.write('<tr><td></td><td></td><td></td></tr>');
		// QR
		a.document.write('<img src="https://i.ibb.co/XkNxMw8/BrinkQR.png" alt="Info" style="width: 155px; max-width: 155px; display: block; margin-left: auto; margin-right: auto;  width: 80%;">')
		a.document.write('</div>');
		a.document.write('</body></html>');

		a.print();
		a.onafterprint = setTimeout(function(){a.close();}, 1000);
	
		//this.stopLoader()

	}
  },
  
};
</script>